import { CardSelectorIllustrationSizeType } from '../../../../../components/cardSelector/types/cardSelectorIllustrationSize';
import { CardSelectorStateType } from '../../../../../components/cardSelector/types/cardSelectorState';
import { TextVariantType } from '../variants';
const commonStyles = (FOUNDATIONS, STATE_TOKENS, isVertical) => ({
    container: {
        display: 'flex',
        flex_direction: 'column',
        padding_bottom: FOUNDATIONS.spacing_250,
        border_width: FOUNDATIONS.border_25,
        border_style: 'solid',
        border_radius: FOUNDATIONS.radius_250,
        ...STATE_TOKENS.container,
    },
    cardIcon: {
        height: FOUNDATIONS.size_350,
        width: FOUNDATIONS.size_350,
        ...STATE_TOKENS.iconCard,
    },
    elementAndTextContainer: {
        padding_top: FOUNDATIONS.spacing_250,
        padding_left: FOUNDATIONS.spacing_250,
        padding_right: FOUNDATIONS.spacing_250,
    },
    selectorIcon: {
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
        ...STATE_TOKENS.selectorIcon,
    },
    elementContainer: {
        padding_bottom: FOUNDATIONS.spacing_150,
        padding_right: FOUNDATIONS.spacing_150,
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: Number(FOUNDATIONS.font_weight_paragraph_medium_regular),
        color: FOUNDATIONS.color_neutral_font_100,
        ...STATE_TOKENS.title,
    },
    bodyContainer: {
        margin_top: FOUNDATIONS.spacing_100,
        ...STATE_TOKENS.bodyContainer,
    },
    body: {
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        font_weight: Number(FOUNDATIONS.font_weight_paragraph_medium_bold),
        color: FOUNDATIONS.color_neutral_font_50,
        ...STATE_TOKENS.body,
    },
    content: {
        margin_top: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.content,
    },
    illustration: {
        [CardSelectorIllustrationSizeType.MEDIUM]: {
            height: FOUNDATIONS.size_600,
            width: FOUNDATIONS.size_600,
        },
    },
    isVertical,
});
export const stylesByOrientation = (FOUNDATIONS, OrientationTokens, isVertical) => ({
    expandedContentContainer: {
        ...OrientationTokens.expandedContentContainer,
    },
    lineSeparatorContainer: {
        margin_top: FOUNDATIONS.spacing_300,
    },
    [CardSelectorStateType.DEFAULT]: {
        ...commonStyles(FOUNDATIONS, {
            container: {
                background_color: FOUNDATIONS.color_comp_containers_bg,
                border_color: FOUNDATIONS.color_neutral_border_160,
            },
            iconCard: {
                color: FOUNDATIONS.color_secondary_icon_100,
            },
            selectorIcon: {
                color: FOUNDATIONS.color_accent_selected_icon_50,
            },
            title: {},
            body: {},
            bodyContainer: {
                ...OrientationTokens.bodyContainer,
            },
            content: {
                ...OrientationTokens.content,
            },
        }, isVertical),
    },
    [CardSelectorStateType.SELECTED]: {
        ...commonStyles(FOUNDATIONS, {
            container: {
                background_color: FOUNDATIONS.color_accent_selected_bg_200,
                border_color: FOUNDATIONS.color_accent_selected_border_50,
            },
            iconCard: {
                color: FOUNDATIONS.color_secondary_icon_100,
            },
            selectorIcon: {
                color: FOUNDATIONS.color_accent_selected_icon_50,
            },
            title: {},
            body: {},
            bodyContainer: {
                ...OrientationTokens.bodyContainer,
            },
            content: {
                ...OrientationTokens.content,
            },
        }, isVertical),
    },
    [CardSelectorStateType.DISABLED]: {
        ...commonStyles(FOUNDATIONS, {
            container: {
                background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                border_color: 'transparent',
            },
            iconCard: {
                color: FOUNDATIONS.color_accent_disabled_icon_100,
            },
            selectorIcon: {
                color: FOUNDATIONS.color_accent_disabled_icon_100,
            },
            title: {
                color: FOUNDATIONS.color_neutral_font_50,
            },
            body: {
                color: FOUNDATIONS.color_neutral_font_50,
            },
            bodyContainer: {
                ...OrientationTokens.bodyContainer,
            },
            content: {
                ...OrientationTokens.content,
            },
        }, isVertical),
    },
    [CardSelectorStateType.DISABLED_SELECTED]: {
        ...commonStyles(FOUNDATIONS, {
            container: {
                background_color: FOUNDATIONS.color_accent_disabled_bg_300,
                border_color: FOUNDATIONS.color_accent_disabled_border_100,
            },
            iconCard: {
                color: FOUNDATIONS.color_accent_disabled_icon_50,
            },
            selectorIcon: {
                color: FOUNDATIONS.color_accent_disabled_icon_50,
            },
            title: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
            },
            body: {
                color: FOUNDATIONS.color_accent_disabled_font_50,
            },
            bodyContainer: {
                ...OrientationTokens.bodyContainer,
            },
            content: {
                ...OrientationTokens.content,
            },
        }, isVertical),
    },
});
//# sourceMappingURL=commonStyles.js.map